export default __webpack_public_path__ + "static/artifakt-element-black-8094c96922583a9f92290800b3eb527f.woff2";